const home = {
	heading: 'Berätta om HIV',
	intro: 'En webbplats som normaliserar och hjälper dig att prata om hiv i vardagen.'
};

export default home;
